export default {"src":"/_next/static/media/man.ddc04719.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};